<div class="{{theme}}-theme">
    <div class="position-relative border-bottom" *ngIf="topic">
        <div class="topic-wrapper">
            <img src="{{topic.featureImageUrl}}" class="topic-featured-img d-lg-none" *ngIf="topic.featureImageUrl" />
            <div class="df-topic border-lg-right">
                <div class="container-fluid">
                    <div class="row py-4">

                        <div class="col-12 pt-3">
                            <h2 class="text-uppercase">{{topic.title}}</h2>
                        </div>
                    </div>
                </div>
                <div class="container-fluid py-4">
                    <div class="row pt-4 pb-3">
                        <div class="col-12 subtitle" [innerHtml]="topic.subtitle"></div>
                    </div>
                    <audio-transcript *ngIf="topic.audioUrl" [source]="topic.audioUrl" [transcript]="topic.transcript"></audio-transcript>
                    <div class="row" *ngIf="!topic.audioUrl" >
                        <div class="col-12 text-large" [innerHTML]="topic.transcript" ></div>
                    </div>
                </div>
                <div class="dark-theme border-lg-bottom-0 d-lg-none w-100"
                    *ngIf="frontlineDataDistributionContentPresent || frontlineCommunityDataContentPresent">
                    <div *ngFor="let item of soicontent.allContent">
                        <ng-container *ngIf="item.discriminator=='FrontlineCommunityDataContent'">
                            <frontline-community-data device="md"></frontline-community-data>
                        </ng-container>
                        <ng-container *ngIf="item.discriminator=='FrontlineDataDistributionContent'">
                            <frontline-data-distribution device="md"></frontline-data-distribution>
                        </ng-container>
                    </div>
                </div>
                <div class="container-fluid"
                    *ngIf="soicontent && soicontent.textContent && soicontent.textContent.length > 0">
                    <div class="row py-4">
                        <div *ngFor="let item of soicontent.allContent" class="offset-2 col-10">
                            <ng-container *ngIf="item.discriminator=='HtmlText'">
                                <div [innerHtml]="item.text"></div>
                            </ng-container>
                            <ng-container *ngIf="item.discriminator == 'Image'">
                                <img src="{{item.imageUrl}}" class="w-100 img-fluid" />
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div [ngClass]="announcement.cssClass" *ngIf="announcement">
                    <div class="container-fluid">
                        <div class="row py-5">
                            <div class="offset-2 col-10">
                                <img src="{{announcement.imageUrl}}" class="img-fluid text-center" />
                                <h2 class="py-3" [innerHtml]="announcement.title"></h2>
                                <div [innerHtml]="announcement.text"></div>
                                <div class="pt-3">
                                    <a class="btn btn-secondary col" href="https://docs.google.com/document/d/1CsOWizWHTujuIzBofoUsazEJ9YYw5ZLgqbd3z4BaxPA/edit?usp=sharing" target="_blank">How the score is calculated</a>
                                    <a class="btn btn-primary col mt-2 text-white" href="mailto:support@equityisdynamic.com?subject=Sphere of Influence Calculator Feedback" target="_blank">Give Feedback</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img *ngIf="topic.featureImageUrl" src="{{topic.featureImageUrl}}"
                class="border-lg-bottom-0 topic-featured-img d-none d-lg-block" />
            <div class="dark-theme border-lg-bottom-0 d-none d-lg-block w-50"
                *ngIf="frontlineDataDistributionContentPresent || frontlineCommunityDataContentPresent">
                <div *ngFor="let item of soicontent.allContent">
                    <ng-container *ngIf="item.discriminator=='FrontlineCommunityDataContent'">
                        <frontline-community-data device="lg"></frontline-community-data>
                    </ng-container>
                    <ng-container *ngIf="item.discriminator=='FrontlineDataDistributionContent'">
                        <frontline-data-distribution device="lg"></frontline-data-distribution>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="df-topic border-lg-right light-theme" *ngIf="zipCodesControlPresent">
        <ng-container *ngFor="let zipCodeData of zipCodes">
            <div class="dark-theme py-4 px-3 border-bottom d-flex align-items-center justify-content-between"
                data-id="{{zipCodeData.id}}">
                <div>
                    <div class="subtitle">{{zipCodeData.zipCode}}</div>
                    <div class="footnote pt-2">{{zipCodeData.city}}, {{zipCodeData.state}}
                    </div>
                </div>
                <div class="">
                    <a class="svg-btn" (click)="deleteZipCode(zipCodeData.zipCode)">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24 8L8 24" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8 8L24 24" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>
            </div>
        </ng-container>
        <div class="d-flex flex-column align-items-center justify-content-center">
            <zipcode-selector #zipCodeSelector [style.display]="this.zipCodes.length < 3 ? 'block' : 'none'">
            </zipcode-selector>
        </div>
    </div>
    <div class="df-topic border-lg-right light-theme-alt">
        <div class="container-fluid" *ngIf="worksheetContentPresent">
            <div class="row py-4">
                <div *ngFor="let item of soicontent.allContent" class="col-12">

                    <ng-container *ngIf="item.discriminator=='WorksheetContent'">
                        <div class="light-theme-alt">
                            <div class="py-3">
                                <h3 class="font-italic worksheet">Worksheet</h3>
                            </div>
                            <div class="pt-3 border-bottom row"></div>
                            <worksheet></worksheet>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="nonAssessmentAnswers && nonAssessmentAnswers.length > 0">
    <div class="reflection-journal-theme border-top border-bottom">
        <div class="container-fluid">
            <div class="row py-4">
                <div class="col-12">
                    <h3 class="font-italic reflection-journal">Reflection Journal</h3>
                </div>
            </div>
        </div>
        <div *ngIf="topicAnswers">
            <div class="border-top" *ngFor="let question of nonAssessmentAnswers; let i=index">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="col-12 col-lg-10" [innerHtml]="question.questionText"></div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-12 col-lg-9">
                            <elemental-input [question]="question"
                                (answerChanged)="answerChanged($event, question.answerId, i)"></elemental-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>


<div class="self-assessment-theme border-bottom" *ngIf="topic && topic.assessments && topic.assessments.length > 0">
    <div class="container-fluid">
        <div class="row py-4">
            <div class="col-12">
                <h3 class="font-italic self-assessment d-flex">Self-assessment</h3>
            </div>
        </div>
    </div>
    <div class="w-100 border-bottom"></div>
    <div class="container-fluid" *ngIf="topic">
        <ng-container *ngFor="let assessment of topic.assessments; let i=index">
            <div class="row pt-3 border-bottom">
                <div class="col-12  subtitle">{{assessment.title}}</div>
                <div class="col-12 py-4">
                    <div class="d-flex flex-column flex-md-row align-items-center">
                        <div class="d-flex ">
                            <div [ngClass]="{ 'soi-assessment-option' : true, 'active': assessment.yesTitleActive }"
                                (click)="assessmentAnswer(assessment.yesText, assessment.id)">
                                <div class="subtitle">{{assessment.yesText}}</div>
                            </div>
                            <div [ngClass]="{ 'soi-assessment-option':true, 'active': assessment.noTitleActive }"
                                (click)="assessmentAnswer(assessment.noText, assessment.id)">
                                <div class="subtitle">{{assessment.noText}}</div>
                            </div>
                        </div>
                        <div class="col py-3">
                            <elemental-input [assessment]="assessment"
                                (answerChanged)="answerChanged($event, assessment.id, i, true)"></elemental-input>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>